import { Button, Tooltip } from "@material-ui/core";
import { FormatListBulleted, ViewList } from "@material-ui/icons";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { postLog } from "../../../../api/log";
import { deleteOwner, getOwnerById, getOwners } from "../../../../api/owner";
import { LOGS } from "../../../../utils/constants";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ArtworkOwnerTableDialog from "../../../components/dialogs/ArtworkOwnerTableDialog";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import Table, {
  buttonsStyle,
  dateFormatter,
  getCurrentTablePage,
} from "../../../components/tables/table";

function getData(owners) {
  let data = [];
  for (let i = 0; i < owners.length; ++i) {
    const elem = {};
    const owner = owners[i];

    elem.fullName = owner?.fullName;
    elem.country = owner?.country;
    elem.company = owner?.company;
    elem.id = owner?._id;

    data = data.concat(elem);
  }
  return data;
}

export default function OwnersPage() {
  const [data, setData] = useState([]);
  const [selectedOwner, setSelectedOwner] = useState(null);

  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const [openArtworkTableDialog, setOpenArtworkTableDialog] = useState(null);
  const [
    openArtworkDesireTableDialog,
    setOpenArtworkDesireTableDialog,
  ] = useState(null);

  const [refresh, setRefresh] = useState(false);

  const location = useLocation();

  const history = useHistory();
  const loggedUser = useSelector(
    (store) => store.authentication?.user,
    shallowEqual
  );

  function buttonFormatter(cell) {
    const elem = data.find((item) => item._id === cell);
    return (
      <>
        <Tooltip title="Edit">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              history.push({
                pathname: "/owners/" + cell + "/edit",
                state: {
                  page: getCurrentTablePage(location),
                },
              });
            }}
          >
            <EditIcon />
          </Button>
        </Tooltip>
        {/* <Tooltip title="Offered Artworks">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              getOwnerById(cell)
                .then((res) => {
                  if (res.status === 200) {
                    setSelectedOwner(res.data);
                    setOpenArtworkTableDialog(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Could not get artworks.",
                  });
                });
            }}
          >
            <ViewList />
          </Button>
        </Tooltip>
        <Tooltip title="Seeked Artworks">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              getOwnerById(cell)
                .then((res) => {
                  if (res.status === 200) {
                    setSelectedOwner(res.data);
                    setOpenArtworkDesireTableDialog(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Could not get artworks.",
                  });
                });
            }}
          >
            <FormatListBulleted />
          </Button>
        </Tooltip> */}
        <Tooltip title="Delete">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              setSelectedOwner(elem);
              setOpenConfirmDialog(true);
            }}
          >
            <DeleteIcon />
          </Button>
        </Tooltip>
      </>
    );
  }

  const columns = [
    { dataField: "fullName", text: "Full Name", sort: true },
    {
      dataField: "country",
      text: "Country",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "company",
      text: "Company",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    { dataField: "id", text: "", formatter: buttonFormatter },
  ];

  useEffect(() => {
    getOwners()
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setRefresh(false);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "Could not get owners.",
        });
      });
  }, [refresh]);

  return (
    <>
      <Card>
        <CardHeader title="Owner list">
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                history.push({
                  pathname: "/owners/edit",
                  state: {
                    page: getCurrentTablePage(location),
                  },
                });
              }}
            >
              Add new
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Table data={getData(data)} columns={columns} />
          <ConfirmDialog
            title={"Are you sure you want to delete this owner?"}
            open={openConfirmDialog}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteOwner(selectedOwner?._id)
                .then((res) => {
                  if (res.status === 204 || res.status === 200) {
                    postLog(
                      loggedUser,
                      LOGS.FIELDS.SUPPLIERS,
                      `${LOGS.ACTIONS.DELETE}-${selectedOwner?.fullName}`
                    );
                    alertSuccess({
                      title: "Deleted!",
                      customMessage: "Owner deleted successfully.",
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Could not delete owner.",
                  });
                });
            }}
          />
          <ArtworkOwnerTableDialog
            title={
              selectedOwner?.fullName +
              ": " +
              (openArtworkTableDialog
                ? "Offered Artworks"
                : openArtworkDesireTableDialog
                ? "Seeked Artworks"
                : "")
            }
            open={openArtworkTableDialog || openArtworkDesireTableDialog}
            setOpen={
              openArtworkTableDialog
                ? setOpenArtworkTableDialog
                : setOpenArtworkDesireTableDialog
            }
            data={selectedOwner}
            artworkOwnerTable={openArtworkTableDialog}
            desireTable={openArtworkDesireTableDialog}
          />
        </CardBody>
      </Card>
    </>
  );
}
